import BusinessSlider from "../components/BusinessListing/BusinessListingDetails/BusinessSlider";
import Filter from "../components/BusinessListing/Filter/Filter";
import Listing from "../components/BusinessListing/Listing/Listing";
import Container from "../components/layout/Container";
import BannerAds from "../components/Shared/BannerAds/BannerAds";

const BusinessListing = () => {
  return (
    <Container>
      <BusinessSlider />
      <div className="flex items-start justify-between gap-4">
        <Filter />
        <Listing />
      </div>
      <div className="mt-10 grid grid-cols-3 gap-10">
        <BannerAds />
        <BannerAds />
        <BannerAds />
      </div>
    </Container>
  );
};

export default BusinessListing;
